document.addEventListener('DOMContentLoaded', function() {
  // Function to update cart totals
  const updateCartTotals = () => {
    // Give the original cart update time to process
    setTimeout(() => {
      fetch(window.routes.cart_url + '?section_id=template--25196591055188__cart-footer')
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const newDoc = parser.parseFromString(html, 'text/html');
          
          // Find the new total value
          const newTotalElement = newDoc.querySelector('.totals__total-value');
          
          // Find the current total element on the page
          const currentTotalElement = document.querySelector('.totals__total-value');
          
          // Update the total if both elements exist
          if (newTotalElement && currentTotalElement) {
            currentTotalElement.textContent = newTotalElement.textContent;
          }
          
          // Hide any error messages that might be showing
          const cartErrors = document.getElementById('cart-errors');
          if (cartErrors) {
            cartErrors.style.display = 'none';
          }
        })
        .catch(error => console.error('Error updating cart total:', error));
    }, 500);
  };

  // Instead of replacing elements, let's monitor the XHR requests
  // This approach intercepts the network requests without affecting DOM elements
  const originalXHROpen = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function() {
    this.addEventListener('load', function() {
      // Check if this is a cart-related request
      if (this.responseURL && (
          this.responseURL.includes('/cart/change') || 
          this.responseURL.includes('/cart/update') || 
          this.responseURL.includes('/cart/add'))) {
        // Update the cart totals when a cart-related request completes
        updateCartTotals();
      }
    });
    originalXHROpen.apply(this, arguments);
  };

  // Additionally, let's monitor fetch requests
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    const promise = originalFetch.apply(this, arguments);
    
    // Check if this is a cart-related request
    if (url && (
        url.includes('/cart/change') || 
        url.includes('/cart/update') || 
        url.includes('/cart/add'))) {
      // Update the cart totals when a cart-related fetch completes
      promise.then(() => {
        updateCartTotals();
      });
    }
    
    return promise;
  };
});